import { render, staticRenderFns } from "./WorldLogin.vue?vue&type=template&id=407f05ca&scoped=true&"
import script from "./WorldLogin.vue?vue&type=script&lang=js&"
export * from "./WorldLogin.vue?vue&type=script&lang=js&"
import style0 from "./WorldLogin.vue?vue&type=style&index=0&id=407f05ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../tasks/spa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407f05ca",
  null
  
)

export default component.exports